import { useCallback } from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { setPopulationHealthAccount } from '../../../../../redux_store';
import AccountSelector from '../../../../Shared/Table/widgets/TopBar/AccountSelector';

const useStyles = makeStyles((theme) => ({
  controlGroup: {
    flex: '0 0 auto',
    paddingBottom: theme.spacing(0),
    borderBottom: 'none',
    marginBottom: theme.spacing(0),

    [theme.breakpoints.up('lg')]: {
      paddingBottom: theme.spacing(2),
      borderBottom: 'none',
      marginBottom: theme.spacing(2),
    },
  },
  sectionTitle: {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 1.5,
    textTransform: 'uppercase',
    color: '#9196A6',
    marginBottom: theme.spacing(1.5),
  },
  selectorWrapper: {
    '& > div': {
      width: '100%',
      backgroundColor: '#F7F8FA',
      borderRadius: 8,
      border: '1px solid #E6E9F0',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: '#F1F3F5',
        borderColor: '#D3D6DC',
      },
    },
  },
}));

const AccountFilter = ({ style }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { en: { populationHealth } } = useSelector((state) => state.i18n);
  const { selectedAccount } = useSelector((state) => state.populationHealth);

  const handleAccountChange = useCallback((account) => {
    dispatch(setPopulationHealthAccount(account));
  }, [dispatch]);

  return (
    <div className={classes.controlGroup} style={style}>
      <Typography className={classes.sectionTitle}>
        {populationHealth?.accountFilter || 'Account'}
      </Typography>
      <div className={classes.selectorWrapper}>
        <AccountSelector
          selectedAccount={selectedAccount}
          onAccountChange={handleAccountChange}
        />
      </div>
    </div>
  );
};

export default AccountFilter;
